import { createFileRoute } from "@tanstack/react-router";
import { TermsContent } from "@/components/content/TermsContent";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — Recovery Trauma™" },
      {
        name: "description",
        content:
          "The terms governing use of the Recovery Trauma™ website, iOS app, membership, community, journals, events and therapist directory.",
      },
      { property: "og:title", content: "Terms of Service — Recovery Trauma™" },
      {
        property: "og:description",
        content:
          "Membership, community, content, therapist directory, liability and consumer rights for Recovery Trauma™.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://recoverytrauma.com/terms" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/terms" }],
  }),
  component: TermsContent,
});
